<template>
<div class="col-12 text-left">
    <app-nav-bar></app-nav-bar>
    <div class="main-content">
         <!-- <h3 class="p-2">
            <small class="text-muted">Customer Complaint Quality</small>
            <app-lookup-field style="float: right;" class="" :model="ccq" :element="timelineLookup"></app-lookup-field>
        </h3> -->
        <div class="row">
            <div class="form-group col-10">
                <h3 class="p-2">
                    <small class="text-muted">Customer Complaint Quality</small>
                </h3>
            </div>
            <div class="form-group col-2">
                <app-lookup-field style="float: right;" :model="ccq" :element="timelineLookup"></app-lookup-field>
            </div>
        </div>
        <div class="p-2 dropdown-divider"></div>
        <div class="row">
            <div class="form-group col-3">
                <label for="module">Complaint Number</label>
                <input type="text" class="form-control" id="complaint-no" v-model="ccq.complaintNo" disabled>
            </div>
            <div class="form-group col-3">
                <label for="module">CCF Log Date</label>
                <flat-pickr class="form-control" v-model="ccq.reportedDate" disabled></flat-pickr>
            </div>
            <div class="form-group col-3">
                <label for="module">Distributed to Internal</label>
                <flat-pickr style="background-color:white;" class="form-control" v-model="ccq.distributedToInternal" disabled></flat-pickr>
            </div>
            <div class="form-group col-3">
                <label for="module">Complaint Received Date</label>
                <flat-pickr style="background-color:white;" class="form-control" v-model="ccq.receivedDate" disabled></flat-pickr>
            </div>
        </div>
        <div class="row">
            <div class="form-group col-3">
                <label for="subject">Customer</label>
                <input type="text" class="form-control" id="customer" v-model="ccq.customerName" disabled>
                <!-- <app-lookup-field :model="ccs" :element="customerLookup" v-on:selectLookup="finishLookup" disabled></app-lookup-field> -->
            </div>
            <div class="form-group col-3">
                <label for="subject">Brand</label>
                <input type="text" class="form-control" id="brand" v-model="ccq.productName" disabled>
                <!-- <app-lookup-field :model="ccs" :element="productLookup" v-on:selectLookup="finishLookup" disabled></app-lookup-field> -->
            </div>
            <div class="form-group col-3">
                <label for="subject">Product</label>
                <input type="text" class="form-control" id="container-no" v-model="ccq.productName" disabled>
            </div>
            <div class="form-group col-3">
                <label for="subject">Plant</label>
                <input type="text" class="form-control" id="container-no" v-model="ccq.plantName" disabled>
            </div>
        </div>
        <div class="row">
            <div class="form-group col-3">
                <label for="module">Address</label>
                <textarea class="form-control" id="desc-textarea" v-model="ccq.address" rows="2" disabled></textarea>
            </div>
            <div class="form-group col-3">
                <label for="module">PIC</label>
                <input type="text" class="form-control" id="pic" v-model="ccq.pic" disabled>
            </div>
            <div class="form-group col-3">
                <label for="module">Email - PIC</label>
                <input type="text" class="form-control" id="email" v-model="ccq.email" disabled>
            </div>
            <div class="form-group col-3">
                <label for="subject">Phone</label>
                <input type="text" class="form-control" id="phone" v-model="ccq.phone" disabled>
            </div>
        </div>
        <!-- <div class="row">
            <div class="form-group col-3">
                <label for="module">PO</label>
                <input type="text" class="form-control" id="po" v-model="ccq.po">
            </div>
            <div class="form-group col-3">
                <label for="module">SO</label>
                <input type="text" class="form-control" id="so" v-model="ccq.so">
            </div>
            <div class="form-group col-3">
                <label for="module">Batch</label>
                <input type="text" class="form-control" id="batch" v-model="ccq.batch">
            </div>
            <div class="form-group col-3">
                <label for="module">Qty.</label>
                <input type="number" class="form-control" id="qty" v-model="ccq.qty">
            </div>
        </div> -->
        <div class="row">
            <div class="form-group col-3">
                <label for="module">BL Date</label>
                <flat-pickr style="background-color:white;" class="form-control" v-model="ccq.blDate" disabled></flat-pickr>
            </div>
            <div class="form-group col-3">
                <label for="module">Dispatch Date</label>
                <flat-pickr style="background-color:white;" class="form-control" v-model="ccq.dispatchDate" disabled></flat-pickr>
            </div>
            <!-- <div class="form-group col-3">
                <label for="module">Discharge Port</label>
                <input type="text" class="form-control" id="discharge-port" v-model="ccq.dischargePort">
            </div> -->
            <div class="form-group col-3">
                <label for="module">Container No.</label>
                <input type="text" class="form-control" id="container-no" v-model="ccq.containerNo" disabled>
            </div>
            <div class="form-group col-3">
                <label for="subject">Packaging</label>
                <input type="text" class="form-control" id="packaging" v-model="ccq.packagingName" disabled>
                <!-- <app-lookup-field :model="ccs" :element="packagingLookup" v-on:selectLookup="finishLookup" disabled></app-lookup-field> -->
            </div>
        </div>
        <div class="row">
            <div class="form-group col-4">
                <label for="module">Discharge Port</label>
                <input type="text" class="form-control" id="discharge-port" v-model="ccq.dischargePortName" disabled>
                <!-- <app-lookup-field :model="ccs" :element="dischargePortLookup" v-on:selectLookup="finishLookup" disabled></app-lookup-field> -->
            </div>
            <div class="form-group col-4">
                <label for="module">Country Name</label>
                <input type="text" class="form-control" id="container-no" v-model="ccq.countryName" disabled>
            </div>
            <!-- <div class="form-group col-4">
                <label for="module">Country Name</label>
                <app-lookup-field :model="ccs" :element="countryLookup" v-on:selectLookup="finishLookup"></app-lookup-field>
            </div> -->
            <div class="form-group col-4">
                <label for="module">Incoterms</label>
                <input type="text" class="form-control" id="model-of-delivery" v-model="ccq.modelOfDeliveryName" disabled>
                <!-- <app-lookup-field :model="ccs" :element="modLookup" v-on:selectLookup="finishLookup" disabled></app-lookup-field> -->
            </div>
        </div>
        <div class="row">
            <div class="form-group col-4">
                <label for="module">Non Conformance Type</label>
                <input type="text" class="form-control" id="conformance-type" v-model="ccq.conformanceTypeName" disabled>
                <!-- <app-lookup-field :model="ccs" :element="conformanceTypeLookup" v-on:selectLookup="finishLookup" disabled></app-lookup-field> -->
            </div>
            <div class="form-group col-4">
                <label for="module">Complaint Media</label>
                <input type="text" class="form-control" id="complaint-media" v-model="ccq.complaintMediaName" disabled>
                <!-- <app-lookup-field :model="ccs" :element="complaintMediaLookup" v-on:selectLookup="finishLookup" disabled></app-lookup-field> -->
            </div>
            <div class="form-group col-4">
                <label for="module">Enclosed</label>
                <input type="text" class="form-control" id="enclosed" v-model="ccq.enclosedName" disabled>
                <!-- <app-lookup-field :model="ccs" :element="enclosedLookup" v-on:selectLookup="finishLookup" disabled></app-lookup-field> -->
            </div>
        </div>
        <div class="row">
            <div class="form-group col-12">
                <label for="module">Description</label>
                <textarea class="form-control" id="desc-textarea" v-model="ccq.description" rows="3" disabled></textarea>
            </div>
        </div>
        <div class="row">
            <div class="form-group col-12">
                <label for="module">Customer Feedback</label>
                <textarea class="form-control" id="desc-textarea" v-model="ccq.feedback" rows="3" disabled></textarea>
            </div>
        </div>
        <div class="row">
            <div v-if="this.$route.query.id !== undefined && this.ccq.ccSalesAttachment !== ''" class="form-group col-3">
               <a :href="this.ccq.ccSalesAttachment" class="badge badge-primary">Download Attachment from Customer</a>
            </div>
            <div v-if="this.$route.query.id !== undefined && this.ccq.ccSalesAttachment === ''" class="form-group col-3">
               <a style="color: white;" class="badge badge-secondary">No Attachment from Customer</a>
            </div>
            <!-- <div v-if="this.$route.query.id !== undefined && this.ccq.ccAreaOwnerAttachment !== ''" class="form-group col-3">
               <a :href="this.ccq.ccAreaOwnerAttachment" class="badge badge-primary">Download Attachment from Quality</a>
            </div>
            <div v-if="this.$route.query.id !== undefined && this.ccq.ccAreaOwnerAttachment === ''" class="form-group col-3">
               <a style="color: white;" class="badge badge-secondary">No Attachment from Quality</a>
            </div> -->
        </div>
        Customer Complaint Detail
        <app-datatable :type="'view'" :newData="newCustomerComplaintDetail" :elements="dtElementsDetail" :collections="ccq.customerComplaintDetail"></app-datatable>
        <br />
        
        <!-- <app-datatable :type="'input'" :newData="newCustomerComplaintQuestion" :elements="dtElementsQuestion" :collections="ccq.customerComplaintQuestion"></app-datatable> -->
        <!-- <br /><br /> -->
        Customer Complaint Question
        <app-datatable :type="'input'" v-if="ccq.transactionStatusCode === 'cc-under-validation'" :newData="newCustomerComplaintQuestion" :elements="dtElementsQuestion" :collections="ccq.customerComplaintQuestion"></app-datatable>
        <app-datatable :type="'view'" v-if="ccq.transactionStatusCode !== 'cc-under-validation'" :newData="newCustomerComplaintQuestion" :elements="dtElementsQuestion" :collections="ccq.customerComplaintQuestion"></app-datatable>
        <!-- Investigation Data
        <app-datatable :type="'input'" :newData="newCustomerComplaintInvestigationDetail" :elements="dtElementsCCInvestigation" :collections="ccq.customerComplaintInvestigationDetail"></app-datatable>
        <br /> -->
        <!-- Corrective Internal Data
        <app-datatable :type="'view'" :newData="newCorrectiveInternal" :elements="dtElementsInternal" :collections="ccq.customerComplaintCorrectiveInternal"></app-datatable>
        <br /><br /> -->
        Root Cause Analysys & Corrective and Preventive Action Internal Data
        <app-datatable :type="'input'" v-if="ccq.transactionStatusCode === 'investigation-on-process'" :newData="newCorrectivePreventiveInternal" :elements="dtElementsCorrectivePreventiveInternal" :collections="ccq.correctivePreventiveInternal"></app-datatable>
        <app-datatable :type="'view'" v-if="ccq.transactionStatusCode !== 'investigation-on-process'" :newData="newCorrectivePreventiveInternal" :elements="dtElementsCorrectivePreventiveInternal" :collections="ccq.correctivePreventiveInternal"></app-datatable>
        <br />
        
        <div class="row" v-if="ccq.transactionStatusCode === 'cc-under-validation'">
            <div class="form-group col-6">
                <label for="owner-member">Owner Area</label>
                <app-lookup-field :model="ccq" :element="ownerLookup" v-on:selectLookup="finishLookup"></app-lookup-field>
            </div>
        </div>

        <div class="row" v-if="ccq.transactionStatusCode === 'investigation-on-process'">
            <div class="form-group col-4">
              <label for="owner-member">Owner Area</label>
              <input type="text" class="form-control" id="owner-name" v-model="ccq.ownerMemberName" disabled>
            </div>
            <div class="form-group col-4">
              <label for="owner-member">Owner Email</label>
              <input type="text" class="form-control" id="owner-email" v-model="ccq.ownerMemberEmail" disabled>
            </div>
            <div class="form-group col-4">
              <label for="owner-member">Head Of Department</label>
              <input type="text" class="form-control" id="owner-email" v-model="ccq.hodName" disabled>
            </div>
        </div>
        <div class="row" v-if="ccq.transactionStatusCode === 'investigation-on-process'">
            <div class="form-group col-6">
              <label for="action">Action</label>
              <select type = "dropdown" class="form-control" id="action" v-model="ccq.action">
                <option v-for="(list, index) in this.actionLists" :key="index" :value="list.value">{{ list.title }}</option>
              </select>
            </div>
            <div class="form-group col-6">
              <label for="comment">Comment</label>
              <textarea class="form-control" id="comment" v-model="ccq.comment" rows="3"></textarea>
            </div>
        </div>
        
        <!-- Corrective External Data
        <app-datatable :type="'view'" :newData="newCorrectiveExternal" :elements="dtElementsExternal" :collections="ccq.customerComplaintCorrectiveExternal"></app-datatable>
        <br /><br /> -->
        <!-- Action Tracker Data
        <app-datatable :type="'view'" :newData="newCustomerComplaintActionTracker" :elements="dtElementsActionTracker" :collections="ccq.customerComplaintActionTracker"></app-datatable>
        <br /><br /> -->
        <!-- Action Tracker Log (Revision)
        <app-datatable :type="'view'" :newData="newCustomerComplaintActionTrackerLog" :elements="dtElementsActionTrackerLog" :collections="ccq.customerComplaintActionTrackerLog"></app-datatable>
        <br /><br /> -->
        <!-- New Revision for Action Tracker
        <app-datatable :type="'input'" :newData="newCustomerComplaintActionTrackerLogNew" :elements="dtElementsActionTrackerLogNew" :collections="ccq.customerComplaintActionTrackerLogNew"></app-datatable> -->
        <button type="button" v-if="ccq.transactionStatusCode === 'cc-under-validation'" class="btn btn-outline-success" @click="approve">Approve <i class="far fa-save"></i></button>
        <button type="button" v-if="ccq.transactionStatusCode === 'cc-under-validation'" class="btn btn-outline-danger" @click="reject" style="margin-left: 20px;">Reject <i class="far fa-save"></i></button>
        <button type="button" v-if="ccq.transactionStatusCode === 'investigation-on-process'" class="btn btn-outline-success" @click="update" style="margin-left: 20px;">Update CPAR Data <i class="far fa-save"></i></button>
        <button type="button" v-if="ccq.transactionStatusCode === 'investigation-on-process'" class="btn btn-outline-success" @click="verify" style="margin-left: 20px;">Update & Verify CPAR Data <i class="far fa-save"></i></button>
        <button type="button" class="btn btn-outline-info" @click="cancel" style="margin-left: 20px;">Cancel <i class="far fa-window-close"></i></button>
        <br /><br />
    </div>
</div>
</template>

<script>
import api from '../../services/api'
import { customerComplaintQuality, customerComplaintDetail, customerComplaintQuestion, customerComplaintInvestigationDetail, 
        customerComplaintCorrectiveExternal, customerComplaintCorrectiveInternal, customerComplaintActionTracker, 
        customerComplaintActionTrackerLog, customerComplaintActionTrackerLogNew, correctivePreventiveInternal } from '../../models/customerComplaintQuality'
import AppLookupField from '../../components/AppLookupField.vue'
import AppDatePicker from '../../components/AppDatePicker.vue'
import AppDropdown from '../../components/AppDropdown.vue'
import AppNavBar from '../../components/AppNavbar.vue'
import AppDatatable from '../../components/AppDatatable.vue'

export default {
    components: {
        AppLookupField, AppDatePicker, AppNavBar, AppDropdown, AppDatatable
    },
    data() {
        return {
          ccq: {...customerComplaintQuality, 
                customerComplaintDetail: [], 
                customerComplaintQuestion: [],
                customerComplaintInvestigationDetail: [], 
                customerComplaintCorrectiveExternal: [], 
                customerComplaintCorrectiveInternal: [], 
                customerComplaintActionTracker: [],
                customerComplaintActionTrackerLog: [],
                customerComplaintActionTrackerLogNew: [],
                correctivePreventiveInternal: []},
          newCustomerComplaintDetail: customerComplaintDetail,
          newCustomerComplaintQuestion: customerComplaintQuestion,
          newCustomerComplaintInvestigationDetail: customerComplaintInvestigationDetail,
          newCustomerComplaintActionTracker: customerComplaintActionTracker,
          newCustomerComplaintActionTrackerLog: customerComplaintActionTrackerLog,
          newCustomerComplaintActionTrackerLogNew: customerComplaintActionTrackerLogNew,
          newCorrectiveExternal: customerComplaintCorrectiveExternal,
          newCorrectiveInternal: customerComplaintCorrectiveInternal,
          newCorrectivePreventiveInternal: correctivePreventiveInternal,
          actionLists: [
                {
                    title: 'Valid',
                    value: 'valid'
                },
                {
                    title: 'Invalid',
                    value: 'invalid'
                },
                {
                    title: 'Feedback',
                    value: 'feedback'
                }
          ],
          dtElementsDetail: [
                {
                    title: 'PO',
                    column: 'po',
                    type: 'text',
                    width: 6,
                },
                {
                    title: 'SO',
                    column: 'so',
                    type: 'text',
                    width: 6,
                },
                {
                    title: 'Batch',
                    column: 'batch',
                    type: 'text',
                    width: 6,
                },
                {
                    title: 'Qty (KG)',
                    column: 'qty',
                    type: 'number',
                    width: 6,
                },
          ],
          dtElementsQuestion: [
                {
                    title: 'Question',
                    column: 'question',
                    type: 'text',
                    width: 6,
                },
                {
                    title: 'Answer',
                    column: 'answer',
                    type: 'text',
                    width: 6,
                    disable: true,
                },
                {
                    title: 'Need Attachment?',
                    column: 'needAttachment',
                    type: 'checkbox',
                    width: 6,
                    disable: true,
                },
                {
                    title: 'Attachment',
                    column: 'attachment',
                    type: 'link',
                    width: 6,
                    disable: true,
                },
          ],
          dtElementsInternal: [
              {
                title: 'Corrective Action Number',
                column: 'correctiveActionNumber',
                type: 'text',
                width: 4,
                disable: true
              },
              {
                title: 'Root Cause',
                column: 'rootCause',
                type: 'dropdown',
                width: 6,
                lists: [
                    {
                        title: 'Machine',
                        value: 'machine'
                    },
                    {
                        title: 'Man',
                        value: 'man'
                    },
                    {
                        title: 'Material',
                        value: 'material'
                    },
                    {
                        title: 'Method',
                        value: 'method'
                    },
                    {
                        title: 'Environment',
                        value: 'environment'
                    }
                ]
              },
              {
                title: 'Corrective',
                column: 'corrective',
                type: 'text',
                width: 6,
              },
              {
                title: 'Corrective Responder Name',
                column: 'correctiveResponderName',
                type: 'lookup',
                width: 6,
                lookup: {
                    id: 'memberCorrective',
                    title: 'Member Data',
                    type: 'table',
                    apiUrl: 'member-management/lookup',
                    filter: ['firstName', 'lastName', 'email'],
                    fields: [
                        {
                            placeholder: 'Corrective Responder Name',
                            width: 5,
                            column: 'correctiveResponderName'
                        }
                    ],
                    dtElements: [
                        {
                            title: 'First Name',
                            column: 'firstName'
                        },
                        {
                            title: 'Last Name',
                            column: 'lastName'
                        },
                        {
                            title: 'Email',
                            column: 'email'
                        },
                    ],
                    affectedField: [
                        {
                            from: 'id',
                            to: 'correctivePicId'
                        },
                        {
                            from: 'firstName',
                            to: 'correctiveResponderName'
                        },
                        {
                            from: 'email',
                            to: 'correctiveResponderEmail'
                        },
                    ]
                },
                disable: true,
              },
              {
                title: 'Corrective Responder Email',
                column: 'correctiveResponderEmail',
                type: 'text',
                width: 4,
                disable: true,
              },
              {
                title: 'Corrective Target Date',
                column: 'correctiveTargetDate',
                type: 'date',
                width: 4,
                disable: true,
              },
              {
                title: 'Preventive',
                column: 'preventive',
                type: 'text',
                width: 6,
              },
              {
                title: 'Preventive Responder Name',
                column: 'preventiveResponderName',
                type: 'lookup',
                width: 6,
                lookup: {
                    id: 'memberPreventive',
                    title: 'Member Data',
                    type: 'table',
                    apiUrl: 'member-management/lookup',
                    filter: ['firstName', 'lastName', 'email'],
                    fields: [
                        {
                            placeholder: 'Preventive Responder Name',
                            width: 5,
                            column: 'preventiveResponderName'
                        }
                    ],
                    dtElements: [
                        {
                            title: 'First Name',
                            column: 'firstName'
                        },
                        {
                            title: 'Last Name',
                            column: 'lastName'
                        },
                        {
                            title: 'Email',
                            column: 'email'
                        },
                    ],
                    affectedField: [
                        {
                            from: 'id',
                            to: 'preventivePicId'
                        },
                        {
                            from: 'firstName',
                            to: 'preventiveResponderName'
                        },
                        {
                            from: 'email',
                            to: 'preventiveResponderEmail'
                        },
                    ]
                },
                disable: true,
              },
              {
                title: 'Preventive Responder Email',
                column: 'preventiveResponderEmail',
                type: 'text',
                width: 4,
                disable: true,
              },
              {
                title: 'Preventive Target Date',
                column: 'preventiveTargetDate',
                type: 'date',
                width: 4,
                disable: true,
              },
          ],
          dtElementsCorrectivePreventiveInternal: [
              {
                title: 'Action No.',
                column: 'actionNo',
                type: 'text',
                width: 4,
                disable: true
              },
              {
                title: 'Root Cause Type',
                column: 'rootCauseType',
                type: 'dropdown',
                width: 6,
                lists: [
                    {
                        title: 'Machine',
                        value: 'Machine'
                    },
                    {
                        title: 'Man',
                        value: 'Man'
                    },
                    {
                        title: 'Material',
                        value: 'Material'
                    },
                    {
                        title: 'Method',
                        value: 'Method'
                    },
                    {
                        title: 'Environment',
                        value: 'Environment'
                    }
                ]
              },
              {
                title: 'Root Cause Remark',
                column: 'rootCauseRemark',
                type: 'text',
                width: 6,
              },
              {
                title: 'Root Cause Remark (External)',
                column: 'rootCauseRemarkExternal',
                type: 'text',
                width: 6,
              },
              {
                title: 'Action Type',
                column: 'actionType',
                type: 'dropdown',
                width: 6,
                lists: [
                    {
                        title: 'Corrective',
                        value: 'Corrective'
                    },
                    {
                        title: 'Preventive',
                        value: 'Preventive'
                    },
                ]
              },
              {
                title: 'Action Remark',
                column: 'actionRemark',
                type: 'text',
                width: 6,
              },
              {
                title: 'Action Remark (External)',
                column: 'actionRemarkExternal',
                type: 'text',
                width: 6,
              },
              {
                title: 'Responder Name',
                column: 'picId',
                type: 'lookup',
                width: 6,
                lookup: {
                    id: 'memberCorrective',
                    title: 'Member Data',
                    type: 'table',
                    apiUrl: 'member-management/lookup',
                    filter: ['firstName', 'lastName', 'email'],
                    fields: [
                        {
                            placeholder: 'Responder Name',
                            width: 5,
                            column: 'picName'
                        }
                    ],
                    dtElements: [
                        {
                            title: 'First Name',
                            column: 'firstName'
                        },
                        {
                            title: 'Last Name',
                            column: 'lastName'
                        },
                        {
                            title: 'Email',
                            column: 'email'
                        },
                    ],
                    affectedField: [
                        {
                            from: 'id',
                            to: 'picId'
                        },
                        {
                            from: 'firstName',
                            to: 'picName'
                        },
                        {
                            from: 'email',
                            to: 'picEmail'
                        },
                    ]
                },
                disable: true,
              },
              {
                title: 'PIC Email',
                column: 'picEmail',
                type: 'text',
                width: 4,
                disable: true,
              },
              {
                title: 'Target Date',
                column: 'targetDate',
                type: 'date',
                width: 4,
                disable: true,
              },
          ],
          dtElementsExternal: [
            {
                title: 'Investigation Detail',
                column: 'investigationDetail',
                type: 'text',
                width: 8,
            },
            {
                title: 'Corrective',
                column: 'corrective',
                type: 'text',
                width: 8,
            },
            {
                title: 'Preventive',
                column: 'preventive',
                type: 'text',
                width: 8,
            },
          ],
          dtElementsCCInvestigation: [
              {
                  title: 'Question',
                  column: 'question',
                  type: 'text',
                  width: 6,
              },
              {
                  title: 'Responder',
                  column: 'responder',
                  type: 'lookup',
                  width: 6,
                  lookup: {
                      id: 'member',
                      title: 'Member Data',
                      type: 'table',
                      apiUrl: 'member-management/lookup',
                      filter: ['firstName', 'lastName', 'email'],
                      fields: [
                          {
                              placeholder: 'Responder',
                              width: 5,
                              column: 'responder'
                          }
                      ],
                      dtElements: [
                          {
                              title: 'First Name',
                              column: 'firstName'
                          },
                          {
                              title: 'Last Name',
                              column: 'lastName'
                          },
                          {
                              title: 'Email',
                              column: 'email'
                          },
                      ],
                      affectedField: [
                          {
                              from: 'id',
                              to: 'memberId'
                          },
                          {
                              from: 'firstName',
                              to: 'responder'
                          },
                          {
                              from: 'email',
                              to: 'email'
                          },
                      ]
                  },
                  disable: true,
              },
              {
                  title: 'Email',
                  column: 'email',
                  type: 'text',
                  width: 4,
                  disable: true,
              },
              {
                  title: 'Answer',
                  column: 'answer',
                  type: 'text',
                  width: 4,
              },
              {
                title: 'Attachment',
                column: 'attachment',
                type: 'link',
                disable: true,
              },
              {
                  title: 'Answered At',
                  column: 'answeredAt',
                  type: 'date',
                  width: 4,
                  disable: true,
              },
          ],
          dtElementsActionTracker: [
            {
                title: 'Corrective Action Number',
                column: 'correctiveActionNumber',
                type: 'text',
                width: 4,
                disable: true
            },
            {
                title: 'Root Cause',
                column: 'rootCause',
                type: 'text',
                width: 6,
            },
            {
                title: 'Type',
                column: 'type',
                type: 'text',
                width: 6,
            },
            {
                title: 'PIC',
                column: 'pic',
                type: 'text',
                width: 6,
            },
            {
                title: 'Email',
                column: 'email',
                type: 'text',
                width: 6,
            },
            {
                title: 'Work Description',
                column: 'workDescription',
                type: 'text',
                width: 6,
            },
            {
                title: 'Evidence',
                column: 'evidence',
                type: 'link',
                width: 6,
            },
            {
                title: 'Completion Date',
                column: 'completionDate',
                type: 'date',
                width: 4,
            },
          ],
          dtElementsActionTrackerLog: [
            {
                title: 'PIC',
                column: 'pic',
                type: 'text',
                width: 6,
            },
            {
                title: 'Email',
                column: 'email',
                type: 'text',
                width: 6,
            },
            {
                title: 'Root Cause',
                column: 'rootCause',
                type: 'text',
                width: 6,
            },
            {
                title: 'Type',
                column: 'type',
                type: 'text',
                width: 6,
            },
            {
                title: 'Item',
                column: 'item',
                type: 'text',
                width: 6,
            },
            {
                title: 'Comment',
                column: 'remark',
                type: 'text',
                width: 6,
            },
            {
                title: 'Revised by User',
                column: 'isAnswered',
                type: 'text',
                width: 6,
            },
          ],
          dtElementsActionTrackerLogNew: [
              {
                  title: 'Action Number',
                  column: 'correctiveActionNumber',
                  type: 'lookup',
                  width: 6,
                  lookup: {
                      id: 'corrective-data',
                      title: 'Action Number data',
                      type: 'table',
                      apiUrl: `customer-complaint-corrective-list/${this.$route.query.id}`,
                      filter: ['actionNo'],
                      fields: [
                          {
                              placeholder: 'Action Number',
                              width: 5,
                              column: 'actionNo'
                          }
                      ],
                      dtElements: [
                          {
                            title: 'Action Number',
                            column: 'actionNo',
                        },
                        {
                            title: 'Root Cause Type',
                            column: 'rootCauseType',
                        },
                        {
                            title: 'Action Type',
                            column: 'actionType',
                        },
                        {
                            title: 'PIC Name',
                            column: 'picName',
                        },
                        {
                            title: 'PIC Email',
                            column: 'picEmail',
                        }
                      ],
                      affectedField: [
                          {
                              from: 'actionNo',
                              to: 'actionNo'
                          },
                          {
                              from: 'picId',
                              to: 'picId'
                          },
                          {
                              from: 'picName',
                              to: 'picName'
                          },
                          {
                              from: 'picEmail',
                              to: 'picEmail'
                          },
                          {
                              from: 'rootCauseType',
                              to: 'rootCauseType'
                          },
                          {
                              from: 'actionType',
                              to: 'actionType'
                          },
                      ]
                  },
                  disable: true,
              },
            {
                title: 'PIC',
                column: 'picName',
                type: 'text',
                width: 4,
                disable: true,
            },  
            {
                title: 'PIC Email',
                column: 'picEmail',
                type: 'text',
                width: 4,
                disable: true,
            },
            {
                title: 'Root Cause Type',
                column: 'rootCauseType',
                type: 'text',
                width: 4,
                disable: true,
              },
            {
                title: 'Action Type',
                column: 'actionType',
                type: 'text',
                width: 6,
                disable: true,
            },
            {
                title: 'Item',
                column: 'item',
                type: 'dropdown',
                width: 6,
                lists: [
                    {
                        title: 'Work Description',
                        value: 'Work Description'
                    },
                    {
                        title: 'Evidence',
                        value: 'evidence'
                    },
                ]
            },
            {
                title: 'Comment',
                column: 'remark',
                type: 'text',
                width: 6,
            },
          ],
            customerLookup: {
                id: 'customer',
                title: 'Customer',
                type: 'form',
                apiUrl: 'customer-list',
                filter: ['name'],
                fields: [
                    {
                        placeholder: 'Customer',
                        width: 12,
                        column: 'customerName'
                    }
                ],
                dtElements: [
                    {
                        title: 'Nama',
                        column: 'name'
                    },
                ],
                affectedField: [
                    {
                        from: 'id',
                        to: 'customerId'
                    },
                    {
                        from: 'name',
                        to: 'customerName'
                    },
                ]
            },

            productLookup: {
                id: 'product',
                title: 'Product',
                type: 'form',
                apiUrl: 'product-list',
                filter: ['name'],
                fields: [
                    {
                        placeholder: 'Product',
                        width: 12,
                        column: 'productName'
                    }
                ],
                dtElements: [
                    {
                        title: 'Nama',
                        column: 'name'
                    },
                    {
                        title: 'Plant Name',
                        column: 'plantName'
                    },
                ],
                affectedField: [
                    {
                        from: 'id',
                        to: 'productId'
                    },
                    {
                        from: 'name',
                        to: 'productName'
                    },
                    {
                        from: 'plantId',
                        to: 'plantId'
                    },
                    {
                        from: 'plantName',
                        to: 'plantName'
                    },
                ]
            },

            plantLookup: {
                id: 'plant',
                title: 'Plant',
                type: 'form',
                apiUrl: 'plant-list',
                filter: ['name'],
                fields: [
                    {
                        placeholder: 'Plant',
                        width: 12,
                        column: 'plantName'
                    }
                ],
                dtElements: [
                    {
                        title: 'Nama',
                        column: 'name'
                    },
                ],
                affectedField: [
                    {
                        from: 'id',
                        to: 'plantId'
                    },
                    {
                        from: 'name',
                        to: 'plantName'
                    },
                ]
            },

            packagingLookup: {
                id: 'packaging',
                title: 'Packaging',
                type: 'form',
                apiUrl: 'packaging-list',
                filter: ['name'],
                fields: [
                    {
                        placeholder: 'Packaging',
                        width: 12,
                        column: 'packagingName'
                    }
                ],
                dtElements: [
                    {
                        title: 'Nama',
                        column: 'name'
                    },
                ],
                affectedField: [
                    {
                        from: 'id',
                        to: 'packagingId'
                    },
                    {
                        from: 'name',
                        to: 'packagingName'
                    },
                ]
            },

            dischargePortLookup: {
                id: 'discharge-port',
                title: 'Discharge Port',
                type: 'form',
                apiUrl: 'discharge-port-list',
                filter: ['name'],
                fields: [
                    {
                        placeholder: 'Discharge Port',
                        width: 12,
                        column: 'dischargePortName'
                    }
                ],
                dtElements: [
                    {
                        title: 'Nama',
                        column: 'name'
                    },
                    {
                        title: 'Country',
                        column: 'countryName'
                    },
                ],
                affectedField: [
                    {
                        from: 'id',
                        to: 'dischargePortId'
                    },
                    {
                        from: 'name',
                        to: 'dischargePortName'
                    },
                    {
                        from: 'countryId',
                        to: 'countryId'
                    },
                    {
                        from: 'countryName',
                        to: 'countryName'
                    },
                ]
            },

            countryLookup: {
                id: 'country',
                title: 'Country',
                type: 'form',
                apiUrl: 'country-list',
                filter: ['name'],
                fields: [
                    {
                        placeholder: 'Country',
                        width: 12,
                        column: 'countryName'
                    }
                ],
                dtElements: [
                    {
                        title: 'Nama',
                        column: 'name'
                    },
                ],
                affectedField: [
                    {
                        from: 'id',
                        to: 'countryId'
                    },
                    {
                        from: 'name',
                        to: 'countryName'
                    },
                ]
            },

            modLookup: {
                id: 'mod',
                title: 'Incoterms',
                type: 'form',
                apiUrl: 'model-of-delivery-list',
                filter: ['name'],
                fields: [
                    {
                        placeholder: 'Incoterms',
                        width: 12,
                        column: 'modelOfDeliveryName'
                    }
                ],
                dtElements: [
                    {
                        title: 'Nama',
                        column: 'name'
                    },
                ],
                affectedField: [
                    {
                        from: 'id',
                        to: 'modelOfDeliveryId'
                    },
                    {
                        from: 'name',
                        to: 'modelOfDeliveryName'
                    },
                ]
            },

            conformanceTypeLookup: {
                id: 'conformance-type',
                title: 'Conformance Type',
                type: 'form',
                apiUrl: 'conformance-type-list',
                filter: ['name'],
                fields: [
                    {
                        placeholder: 'Non Conformance Type',
                        width: 12,
                        column: 'conformanceTypeName'
                    }
                ],
                dtElements: [
                    {
                        title: 'Nama',
                        column: 'name'
                    },
                ],
                affectedField: [
                    {
                        from: 'id',
                        to: 'conformanceTypeId'
                    },
                    {
                        from: 'name',
                        to: 'conformanceTypeName'
                    },
                ]
            },

            complaintMediaLookup: {
                id: 'complaint-media',
                title: 'Complaint Media',
                type: 'form',
                apiUrl: 'complaint-media-list',
                filter: ['name'],
                fields: [
                    {
                        placeholder: 'Complaint Media',
                        width: 12,
                        column: 'complaintMediaName'
                    }
                ],
                dtElements: [
                    {
                        title: 'Nama',
                        column: 'name'
                    },
                ],
                affectedField: [
                    {
                        from: 'id',
                        to: 'complaintMediaId'
                    },
                    {
                        from: 'name',
                        to: 'complaintMediaName'
                    },
                ]
            },

            enclosedLookup: {
                id: 'enclosed',
                title: 'Enclosed',
                type: 'form',
                apiUrl: 'enclosed-list',
                filter: ['name'],
                fields: [
                    {
                        placeholder: 'Enclosed',
                        width: 12,
                        column: 'enclosedName'
                    }
                ],
                dtElements: [
                    {
                        title: 'Nama',
                        column: 'name'
                    },
                ],
                affectedField: [
                    {
                        from: 'id',
                        to: 'enclosedId'
                    },
                    {
                        from: 'name',
                        to: 'enclosedName'
                    },
                ]
            },
            ownerLookup: {
              id: 'owner-area',
              title: 'Owner Area',
              type: 'form',
              apiUrl: 'member-management/lookup',
              filter: ['firstName', 'lastName', 'email'],
              fields: [
                  {
                      placeholder: 'Name',
                      width: 6,
                      column: 'ownerMemberName'
                  },
                  {
                      placeholder: 'Email',
                      width: 6,
                      column: 'ownerMemberEmail'
                  },
              ],
              dtElements: [
                  {
                      title: 'Name',
                      column: 'firstName'
                  },
                  {
                      title: 'Email',
                      column: 'email'
                  },
              ],
              affectedField: [
                  {
                      from: 'id',
                      to: 'ownerMemberId'
                  },
                  {
                      from: 'firstName',
                      to: 'ownerMemberName'
                  },
                  {
                      from: 'email',
                      to: 'ownerMemberEmail'
                  },
              ]
          },
          timelineLookup: {
            id: 'timeline-lookup',
            title: 'Timeline',
            type: 'form',
            apiUrl: `get-timeline-combine-data/${this.$route.query.id}`,
            filter: ['actualStatusFrom'],
            fields: [
                {
                    placeholder: 'Check Timeline',
                    width: 12,
                    column: 'actualStatusFrom'
                }
            ],
            dtElements: [
                {
                    title: 'Status',
                    column: 'actualStatusFrom'
                },
                {
                    title: 'Actual Date',
                    column: 'actualDate'
                },
                {
                    title: 'Plan Date',
                    column: 'planDate'
                },
            ],
            affectedField: [
                {
                    from: '',
                    to: ''
                },
            ]
          },
        //     timelineLookup: {
        //     id: 'timeline',
        //     title: 'Timeline',
        //     content: '',
        //     searchBar: false,
        //     type: 'table',
        //     filter: ['actualStatusFrom', 'actualDate', 'planDate'],
        //     needAutoClose: false,
        //     dtElements: [
        //         {
        //             id: 'actualStatusFrom',
        //             title: 'From',
        //             type: 'text',
        //             column: 'actualStatusFrom'
        //         },
        //         {
        //             id: 'actualDate',
        //             title: 'Actual Date',
        //             type: 'text',
        //             column: 'actualDate'
        //         },
        //         {
        //             id: 'planDate',
        //             title: 'Plan Date',
        //             type: 'text',
        //             column: 'planDate'
        //         },
        //     ]
        // },
        }
    },
    async created() {
        if(this.$route.query.id !== undefined) {
            const ccqApi = api('customer-complaint-final-approval')
            this.ccq = await ccqApi.getWithParams(this.$route.query.id)
        }
        // console.log(this.ccq);
    },
    methods: {
        async approve() {
            const ccqApi = api('customer-complaint-quality/approve')
            if(this.$route.query.id !== undefined) {
                await ccqApi.update(this.ccq, this.$route.query.id)
            }
            // this.$router.go(-1)
            this.$router.push({ name: 'customerComplaintInvestigationAnswerSubmitted' })
        },
        async reject() {
            const ccqApi = api('customer-complaint-quality/reject')
            if(this.$route.query.id !== undefined) {
                await ccqApi.update(this.ccq, this.$route.query.id)
            }
            // this.$router.go(-1)
            this.$router.push({ name: 'customerComplaintInvestigationAnswerSubmitted' })
        },
        async update() {
            const ccqApi = api('customer-complaint-quality/update')
            if(this.$route.query.id !== undefined) {
                await ccqApi.update(this.ccq, this.$route.query.id)
            }
            // this.$router.go(-1)
            this.$router.push({ name: 'customerComplaintInvestigationAnswerSubmitted' })
        },
        async verify() {
            const ccqApi = api('customer-complaint-quality/verify')
            if(this.$route.query.id !== undefined) {
                await ccqApi.update(this.ccq, this.$route.query.id)
            }
            // this.$router.go(-1)
            this.$router.push({ name: 'customerComplaintInvestigationAnswerSubmitted' })
        },
        // async update() {
        //     const ccqApi = api('customer-complaint-final-approval/update')
        //     if(this.$route.query.id !== undefined) {
        //         await ccqApi.update(this.ccq, this.$route.query.id)
        //     }
        //     this.$router.go(-1)
        // },
        cancel() {
            this.$router.go(-1)
        },
        finishLookup(data) {
            const currentccq = this.ccq
            this.ccq = {
                ...currentccq,
                ...data
            }
            // console.log(this.ccq);
        }
    }
}
</script>